import {Time} from 'yougile-util'
import {StickerEditorState} from '../../sticker-editor-store'

const oneDayMs = 24 * 60 * 60 * 1000

export const getSprintInitValues = (state: StickerEditorState) => {
  if (state.sprintState?.begin || state.sprintState?.end) {
    const begin = state.sprintState?.begin || Time.now()
    const end = state.sprintState?.end || Time.now()
    const initialBegin = Time.toLocalDate(begin)
    const initialEnd = Time.toLocalDate(end)

    return {initialBegin, initialEnd}
  }

  if (!state.sprintStates || !state.sprintStates.length) {
    const initialBegin = Time.toLocalDate(Time.now())
    const initialEnd = Time.toLocalDate(Time.now())

    return {initialBegin, initialEnd}
  }

  const prev = state.sprintStates[0]
  // skip like backlog
  if (!prev.end || !prev.begin) {
    const initialBegin = Time.toLocalDate(Time.now())
    const initialEnd = Time.toLocalDate(Time.now())

    return {initialBegin, initialEnd}
  }

  const diff = prev.end - prev.begin

  return {
    initialBegin: Time.toLocalDate(prev.end + oneDayMs),
    initialEnd: Time.toLocalDate(prev.end + diff + oneDayMs)
  }
}
